module.exports = __webpack_public_path__ + "static/media/offer-sv-1.d325b660.png";